import { BlankEditorDoTest } from '@doltech/ui/lib/figma/BlankEditor/DoTest/BlankEditorDoTest';
import { Box } from '@doltech/ui/lib/figma/Common/Box';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { DoTestCompletionNoHintQuestionInstance } from '../student-do-test/model/Question/do-test-completion-no-hint-question.store';
import { useTestSubmissionStore } from '../student-do-test/model/test-submissions.hook';

export interface CompletionNoHintAnswerProps extends React.HTMLAttributes<HTMLDivElement> {
  data: DoTestCompletionNoHintQuestionInstance;
}

export const Main = styled(Box)`
  display: grid;
  gap: 16px;
`;

export const Heading = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 16px;
`;

export const BlankEditorDoTestWrapper = styled(BlankEditorDoTest)`
  p:last-child {
    margin-bottom: unset;
  }
  &.blank-container {
    line-height: 24px;
  }
`;

export const CompletionNoHintAnswer = observer((props: CompletionNoHintAnswerProps) => {
  const { data } = props;
  const { heading, paragraph, getUserAnswers, setParagraph } = data;
  const store = useTestSubmissionStore();

  return (
    <Main className="dol-question">
      <Heading>{heading}</Heading>
      <BlankEditorDoTestWrapper
        key={paragraph.id}
        className="blank-container"
        editorValue={paragraph.editorValueJS}
        no={data.no}
        blanks={paragraph.blanks as any[]}
        blankValues={getUserAnswers()}
        onBlankChange={(input) => {
          if (store.preventUserAction()) return;
          data.onAnswerQuestion(input);
        }}
        onEditorChange={setParagraph}
        withToolBar
      />
    </Main>
  );
});
